module.exports = __webpack_public_path__ + "media/icons/standard-6b5ea4ed.svg";